import React, { Component } from 'react';
import { Card, Form, Input, Radio, Spin, Button, Checkbox } from 'antd'; // DatePicker
import { UploadImageV2 } from 'components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ProjectsActions } from 'redux/actions';
import { Row, Col } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import {
  numberWithCommas,
  Modal,
  SecondaryButton,
  SpaceBetween,
  AddFormItemLabel,
  AddInput,
  AddModal,
  AddButtonWrapper,
  AddSaveHint,
  isPromotionEligible,
} from 'utils';
import 'moment/locale/de';
// import locale from 'antd/es/date-picker/locale/de_DE';

// import pickBy from 'loadsh/pickBy';
// import identity from 'loadsh/identity';
import {
  Container,
  PrimaryButton,
  PrimaryButtonV2,
  formLayout,
  formValidateMessages,
  // H2,
  FormWrapper,
} from 'utils';
import styled from '@emotion/styled';
import RichText from './RichText';
import FormList from 'antd/lib/form/FormList';
import RewardsModal from './RewardsModal/RewardsModal';

const FormItem = Form.Item;

const BottomText = styled.div`
  /* Heading */
  /* Text sm/Regular */
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */
  text-align: center;

  color: #717680;

`;

const CurrencyWrapper = styled.div`
  .custom-currency-input {
    position: relative;

    &::before {
      content: 'EUR';
      position: absolute;
      left: 0;
      top: 0;
      width: 54px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px 0px 0px 10px;
      color: #535862 !important;
      font-size: 16px;
      padding-top: 2px;
      background-color: #fff;
      border: 1px solid #d9d9d9;
      z-index: 2;
    }

    input {
      width: 100%;
      height: 44px;
      padding-left: 64px;
      border-radius: 10px !important;
      box-sizing: border-box;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      background-color: #fff;
      border: 1px solid #d9d9d9;
      transition: all 0.3s;
      position: relative;
      z-index: 1;
    }
    input:hover {
      border-color: #1890ff;
    }
    input:focus-visible {
      border-color: #1890ff;
      outline: none;
    }
  }
`;

const CheckboxWrapper = styled.div`
    margin: 0 auto;
    max-width: 600px;
    width: 100%;
  .ant-checkbox-wrapper .ant-checkbox {
    border-radius: 6px;

  }
`;

const CenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const AddFormItem = styled(FormItem)`
  margin-bottom: 0;
`;

const ModalFormItem = styled(FormItem)`
  margin-bottom: 16px;
`;

const AddLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #181d27;
    line-height: 24px;
    margin-bottom: 16px;
    font-family: 'Inter', sans-serif;
`;

const TitleLable = styled.div`
  font-size: 18px;
  font-wight: 600;
  color: #181d27;
    margin-top: -50px
`;

class Rewards extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      addNewReward: false,
      showMaxStock: false,
      showExtraDetails: false,
      hide_ticket_sales_count: props?.project?.hide_ticket_sales_count ?? false,
      // Form Elements
      rewardID: null,
      title: null,
      image: [],
      // mobile_image: null,
      price: null,
      address_required: null,
      description: null,
      shipping_date: null,
      max_order_count: null,
      extra_details: null,
      variants: [],
      no_multi_order: null,
      questions: [],
      // Modal
      showModal: false,
      showAddModal: false,
      selectedDeleteReward: null,
      showErrors: false,
    };
  }

  static propTypes = {
    updateDraft: PropTypes.func.isRequired,
    updateDraftReward: PropTypes.func.isRequired,
    deleteDraftReward: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    isUniq: PropTypes.bool.isRequired,
    checkUrl: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    projectId: PropTypes.string,
    currentStep: PropTypes.number.isRequired,
    setCanMove: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    selectedStep: PropTypes.number.isRequired,
    setSubmitFromModal: PropTypes.func.isRequired,
    handleExitEditForm: PropTypes.func.isRequired,
    editProject: PropTypes.bool.isRequired,
  };

  normalizeVariants = (variants = []) =>
    variants
      .map((variant) => {
        const attribute = variant?.attribute?.trim?.() || '';
        const options = (variant?.options || [])
          .map((option) => option?.trim?.() || '')
          .filter(Boolean);

        return {
          ...variant,
          attribute,
          options,
        };
      })
      .filter((variant) => variant.attribute && variant.options.length > 0);

  onFinish = (values) => {
    // Add The value to the Rewards
    const { description } = values;
    const reward = {
      id: this.state.rewardID,
      title: this.state.title,
      price: this.state.price,
      address_required: this.state.address_required,
      description: description,
      shipping_date: this.state.shipping_date,
      max_order_count: this.state.showMaxStock
        ? this.state.max_order_count
        : null,
      no_multi_order: this.state.no_multi_order,
      extra_details: this.state.showExtraDetails
        ? this.state.extra_details
        : null,
      variants: this.normalizeVariants(this.state.variants),
      questions: this.state.questions,
    };

    this.setState({
      showAddModal: false,
      addNewReward: false,
    });

    // Changing the format of the object sent to match the request
    const objectToSend = {
      reward: { ...reward },
    };

    const formData = new FormData();
    // Check if the Image has the correct attributes
    if (this.state.image[0] && this.state.image[0].originFileObj) {
      formData.append(
        'reward[image]',
        this.state.image[0].originFileObj,
        this.state.image[0].name
      );
    }

    this.resetReward();

    // if (this.state.mobile_image[0] && this.state.mobile_image[0].originFileObj) {
    //   formData.append(
    //     'reward[mobile_image]',
    //     this.state.mobile_image[0].originFileObj,
    //     this.state.mobile_image[0].name
    //   );
    // }
    const {
      updateDraftReward,
      projectId,
      currentStep,
      setCanMove,
      showModal,
      selectedStep,
      setSubmitFromModal,
    } = this.props;
    if (showModal) {
      updateDraftReward(projectId, objectToSend, formData, selectedStep - 1);
      setSubmitFromModal(false);
    } else {
      if (this.props.editProject) updateDraftReward(projectId, objectToSend, formData, currentStep - 1);
      else updateDraftReward(projectId, objectToSend, formData, currentStep);
    }
    setCanMove(true);
  };

  setCoverImage = (image) => this.setState({ image: image || [] });

  resetReward = () => {
    this.setState({
      rewardID: null,
      title: null,
      image: [],
      price: null,
      address_required: null,
      description: null,
      shipping_date: null,
      max_order_count: null,
      extra_details: null,
      variants: [],
      no_multi_order: null,
      questions: [],
    });
  };

  handleAddQuestionClick = () => {
    this.setState({ questions: [...this.state.questions, ['']] });
  };

  handleAddAnswerClick = (i) => {
    this.setState({
      questions: this.state.questions.map((question, index) => {
        return index === i ? [...question, ''] : question;
      }),
    });
  };

  handleRemoveReward = () => {
    const { projectId, currentStep, setCanMove, deleteDraftReward } =
      this.props;

    if (this.props.editProject) deleteDraftReward(projectId, this.state.selectedDeleteReward, currentStep - 1);
    else deleteDraftReward(projectId, this.state.selectedDeleteReward, currentStep);

    this.handelCloseModal();
    setCanMove(true);
  };

  handleInputChange = (e, i, j) => {
    this.setState({
      // eslint-disable-next-line array-callback-return
      questions: this.state.questions.map((question, index) => {
        const { value } = e.target;
        let temp_question = question;
        if (index === i) {
          temp_question[j] = value;
        }
        return temp_question;
      }),
    });
  };
  handleRemoveQuestionAnswer = (i, j) => {
    // if j is 0 that means it is a question
    if (j === 0) {
      const tempArray = [...this.state.questions];
      tempArray.splice(i, 1);
      this.setState({
        questions: [...tempArray],
      });
    }
    // Else that means it is an answer
    else {
      const tempArray = [...this.state.questions];
      tempArray[i].splice(j, 1);
      this.setState({
        questions: [...tempArray],
      });
    }
  };

  handleEditReward = (reward) => {
    this.setState({
      addNewReward: true,
      showAddModal: true,
      rewardID: reward.id,
      title: reward.title,
      image: [], //[reward.image],
      // mobile_image: [reward.mobile_image],
      price: reward.price,
      address_required: reward.address_required,
      description: reward.description,
      shipping_date: reward.shipping_date,
      showMaxStock: reward.max_order_count ? true : false,
      showExtraDetails: reward.extra_details ? true : false,
      max_order_count: reward.max_order_count,
      extra_details: reward.extra_details,
      variants: reward.variants,
      no_multi_order: reward.no_multi_order,
      questions: reward.questions,
    });
  };

  handelCloseModal = () => {
    this.setState({ showModal: false, selectedDeleteReward: null });
  };

  handleCloseAddModal = () => {
    this.setState({ showAddModal: false, addNewReward: false });
    this.resetReward();
  };

  onReturn = () => {
    if (this.props.editProject) this.props.handleExitEditForm();
    else this.props.handleSteps(this.props.project?.is_ticketable ? 6 : 18);
  };

  onContinue = () => {

    if(this.props.project?.fundingTarget?.is_ticketable){
      //Rewards are mandatory

      if(this.props.project?.rewards?.length === 0){
        //Show error that at least 1 reward is required
        alert("Bitte füge mindestens ein Ticket hinzu, um fortzufahren.")
        return;
      }

    }

      this.props.updateDraft(this.props.projectId, {
        hide_ticket_sales_count: this.state.hide_ticket_sales_count,
        is_goodies_done: true,
      });

      if (
        this.props.promotionModuleEnabled &&
        isPromotionEligible(this.props.project, this.props.minFundingGoal)
      ) {
        if(!this.props.project?.is_ticketable){
          this.props.handleSteps(20);
        }else{
          this.props.handleSteps(19);
        }

      } else {
        this.props.handleSteps(19);
      }
      // if (this.props.editProject) this.props.handleSteps(7);
      // else this.props.handleSteps(8);
  };

  getContent = (content, name) => {
    this.formRef.current.setFieldsValue({ [name]: content });
  };

  render() {
    const {
      project,
      loading,
      // isUniq,
      setCanMove,
      projectId,
      editProject,
    } = this.props;


    const isEvent = project?.fundingTarget?.is_ticketable ?? false;

    return (
      <Container className="" style={{ maxWidth: 600 }}>
        <Spin spinning={loading}>
          <IntroBlock>
            <IntroTitle>
              {isEvent ? 'Tickets' : 'Goodies (optional)'}
            </IntroTitle>

            {isEvent ? (
              <>
                <IntroLead>Tickets sind die Zugänge zu deinem Event.</IntroLead>

                <IntroText>
                  Sie sollten immer einen klaren Bezug zur Veranstaltung haben.
                  Kalkuliere zusätzliche Leistungen (z. B. Gebühren, Essen,
                  Materialien) im Preis mit ein. Beschreibe die Tickets klar und
                  ansprechend – und füge ein passendes Bild hinzu, damit
                  Teilnehmende sofort verstehen, was sie erwartet.
                </IntroText>

                <IntroList>
                  <li>
                    Lege für jede Ticketart (z. B. VIP, ermäßigt, Early Bird)
                    ein eigenes Ticket an.
                  </li>

                  <li>
                    Stelle zusätzliche Fragen nur dann, wenn es nötig ist – etwa
                    zu Essenswünschen oder T-Shirt-Größen.
                  </li>
                </IntroList>

                <IntroText>
                  Hinweis: Die Angaben deiner Besucher zu deinen Tickets findest
                  du später in deinem Profil unter „Goodies“.
                </IntroText>
              </>
            ) : (
              <>
                <IntroLead>
                  Goodies sind die Gegenleistungen, die du deiner Community für
                  ihre Unterstützung anbietest.
                </IntroLead>

                <IntroText>
                  Ob materiell oder immateriell – z. B. ein Produkt, Tickets,
                  Workshops oder exklusive Erlebnisse.
                </IntroText>

                <IntroList>
                  <li>
                    Goodies sollten einen klaren Bezug zu deinem Projekt haben.
                  </li>

                  <li>
                    Versandkosten sollten idealerweise im Preis berücksichtigt
                    werden.
                  </li>

                  <li>
                    Gestalte sie ansprechend, um deine Unterstützer zu
                    begeistern.
                  </li>

                  <li>
                    Du kannst Goodies bis zum Ende der Finanzierungsphase
                    jederzeit hinzufügen oder bearbeiten.
                  </li>
                </IntroList>
              </>
            )}
          </IntroBlock>
          {isEvent && (
            <CheckboxWrapper
              style={{
                marginTop: '24px',
                marginBottom: '24px',
              }}
            >
              <Checkbox
                checked={this.state.hide_ticket_sales_count}
                onChange={(e) =>
                  this.setState({ hide_ticket_sales_count: e.target.checked })
                }
                style={{
                  fontSize: '16px',

                  fontWeight: 500,
                  fontFamily: 'Inter, sans-serif',
                  color: '#414651',
                }}
              >
                Verkaufszahlen vor anderen verbergen
              </Checkbox>

              <div
                style={{
                  marginTop: '2px',

                  marginLeft: '28px',

                  fontSize: '16px',

                  lineHeight: '24px',
                  fontFamily: 'Inter, sans-serif',
                  color: '#535862',
                }}
              >
                Ich möchte nicht preisgeben, wie viele Tickets bereits verkauft
                worden bzw. noch übrig sind.
              </div>
            </CheckboxWrapper>
          )}
          {!loading &&
            this.state.addNewReward === false &&
            project.rewards?.length === 0 && (
              <div
                style={{
                  margin: '20px',
                  textAlign: 'center',
                }}
              >
                <CenterWrapper>
                  <PrimaryButtonV2
                    primary={true}
                    minWidth="183px"
                    style={{ height: '48px' }}
                    onClick={() => {
                      this.setState({ addNewReward: true, showAddModal: true });
                    }}
                  >
                    <p>{isEvent ? 'Ticket' : 'Goodie'} Hinzufügen</p>
                  </PrimaryButtonV2>

                  <BottomText>
                    Du kannst diesen Schritt jetzt überspringen und auch{' '}
                    {window.innerWidth > 500 && <br />}
                    später noch {isEvent ? 'Tickets' : 'Goodies'} hinzufügen und
                    bearbeiten.
                  </BottomText>
                </CenterWrapper>
              </div>
            )}
          {!loading &&
            this.state.addNewReward === false &&
            project.rewards?.length !== 0 && (
              <div>
                {projectId &&
                  project.rewards.map((reward, i) => {
                    let img = reward.image;
                    return (
                      <Row>
                        <Col
                          key={i}
                          // xs={{ span: 24, offset: 0 }}
                          // md={{ span: 24, offset: 0 }}
                          // sm={{ span: 24, offset: 0 }}
                          lg={{ span: 10, offset: 0 }}
                          xl={{ span: 10, offset: 0 }}
                          xxl={{ span: 10, offset: 0 }}
                          style={{ padding: '10px' }}
                        >
                          <img alt="reward-card" src={img} />
                        </Col>
                        <Col
                          key={i}
                          // xs={{ span: 24, offset: 0 }}
                          // md={{ span: 24, offset: 0 }}
                          // sm={{ span: 24, offset: 0 }}
                          lg={{ span: 14, offset: 0 }}
                          xl={{ span: 14, offset: 0 }}
                          xxl={{ span: 14, offset: 0 }}
                        >
                          <Card style={{ border: 'none' }}>
                            <div
                              style={{
                                fontSize: '20px',
                                fontWeight: '600',
                              }}
                            >
                              {reward.title}
                            </div>
                            <div
                              style={{
                                fontSize: '16px',
                                color: '#414651',
                              }}
                              dangerouslySetInnerHTML={{
                                __html: reward.description,
                              }}
                            />

                            {reward.variants && reward.variants.length > 0 && (
                              <div
                                style={{
                                  fontSize: '14px',
                                  color: '#535862',
                                }}
                              >
                                {'Varianten:'}{' '}
                                {reward.variants.map((variant, index) => (
                                  <div key={index}>
                                    <b>{variant.attribute}:</b>{' '}
                                    {variant.options?.join(', ')}
                                  </div>
                                ))}
                              </div>
                            )}
                            {!isEvent && (
                              <div
                                style={{
                                  fontSize: '14px',
                                  color: '#535862',
                                }}
                              >
                                {reward.shipping_date
                                  ? 'Goodie ist sofort verfügbar'
                                  : 'Goodie ist erst nach erfolgreichem Crowdfunding verfügbar'}
                              </div>
                            )}
                            {!reward.address_required || (
                              <div
                                style={{
                                  fontSize: '14px',
                                  color: '#535862',
                                }}
                              >
                                {'Lieferadresse des Unterstützers benötigt'}
                              </div>
                            )}
                            {!reward.no_multi_order || (
                              <div
                                style={{
                                  fontSize: '14px',
                                  color: '#535862',
                                }}
                              >
                                {isEvent
                                  ? 'Nur ein Ticket pro Unterstützer'
                                  : 'Nur ein Goodie pro Unterstützer'}
                              </div>
                            )}
                            {!reward.extra_details || (
                              <div
                                style={{
                                  fontSize: '14px',
                                  color: '#535862',
                                }}
                              >
                                {'Unterstützer müssen '}
                                <b>{reward.extra_details}</b>
                                {' angeben.'}
                              </div>
                            )}
                            {!reward.max_order_count || (
                              <div
                                style={{
                                  fontSize: '14px',
                                  color: '#535862',
                                }}
                              >
                                {'Stückzahl ist limitiert auf '}
                                <b>{reward.max_order_count}</b>
                              </div>
                            )}
                            <div
                              style={{
                                fontSize: '20px',
                                fontWeight: '600',
                                marginTop: '10px',
                              }}
                            >
                              {numberWithCommas(
                                Number(reward.price).toFixed(2)
                              )}{' '}
                              €
                            </div>

                            <div
                              style={{ display: 'flex', flexDirection: 'row' }}
                            >
                              <Button
                                type="text"
                                style={{
                                  fontSize: '16px',
                                  fontWeight: '600',
                                  color: '#3F621A',
                                  paddingLeft: '0px',
                                }}
                                onClick={() => this.handleEditReward(reward)}
                              >
                                Bearbeiten
                              </Button>
                              <Button
                                type="link"
                                style={{
                                  fontSize: '16px',
                                  fontWeight: '600',
                                  color: '#3F621A',
                                  paddingLeft: '0px',
                                }}
                                onClick={() =>
                                  this.setState({
                                    showModal: true,
                                    selectedDeleteReward: reward.id,
                                  })
                                }
                              >
                                Löschen
                              </Button>
                            </div>
                          </Card>
                        </Col>
                      </Row>
                    );
                  })}

                <div
                  style={{
                    margin: '20px',
                    textAlign: 'center',
                  }}
                >
                  <CenterWrapper>
                    <PrimaryButtonV2
                      primary={true}
                      minWidth="183px"
                      style={{ height: '48px' }}
                      onClick={() => {
                        this.setState({
                          addNewReward: true,
                          showAddModal: true,
                        });
                      }}
                    >
                      <p>{isEvent ? 'Ticket' : 'Goodie'} Hinzufügen</p>
                    </PrimaryButtonV2>
                  </CenterWrapper>
                </div>

                <Modal
                  showModal={this.state.showModal}
                  handelCloseModal={this.handelCloseModal}
                >
                  <div style={{ padding: '10px 30px' }}>
                    <div style={{ fontSize: '24px' }}>
                      Bist du sicher, dass du fortfahren möchtest?
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        marginTop: '20px',
                      }}
                    >
                      <PrimaryButton onClick={() => this.handleRemoveReward()}>
                        Bestätigen
                      </PrimaryButton>
                      <PrimaryButton
                        onClick={() => this.handelCloseModal()}
                        style={{ backgroundColor: '#F44336', color: '#FFF' }}
                      >
                        Abbrechen
                      </PrimaryButton>
                    </div>
                  </div>
                </Modal>
              </div>
            )}

          {/* Add New Screen */}

          <RewardsModal
            showAddModal={this.state.showAddModal}
            handleCloseAddModal={this.handleCloseAddModal}
            isEvent={isEvent}
            formRef={this.formRef}
            onFinish={this.onFinish}
            setCanMove={setCanMove}
            showErrors={this.state.showErrors}
            setShowErrors={(showErrors) => this.setState({ showErrors })}
            image={this.state.image}
            setCoverImage={this.setCoverImage}
            title={this.state.title}
            setTitle={(title) => this.setState({ title })}
            price={this.state.price}
            setPrice={(price) => this.setState({ price })}
            description={this.state.description}
            getContent={this.getContent}
            variants={this.state.variants}
            setVariants={(variants) => this.setState({ variants })}
            shippingDate={this.state.shipping_date}
            setShippingDate={(shipping_date) =>
              this.setState({ shipping_date })
            }
            addressRequired={this.state.address_required}
            setAddressRequired={(address_required) =>
              this.setState({ address_required })
            }
            noMultiOrder={this.state.no_multi_order}
            setNoMultiOrder={(no_multi_order) =>
              this.setState({ no_multi_order })
            }
            showExtraDetails={this.state.showExtraDetails}
            setShowExtraDetails={(showExtraDetails) =>
              this.setState({ showExtraDetails })
            }
            extraDetails={this.state.extra_details}
            setExtraDetails={(extra_details) =>
              this.setState({ extra_details })
            }
            showMaxStock={this.state.showMaxStock}
            setShowMaxStock={(showMaxStock) => this.setState({ showMaxStock })}
            maxOrderCount={this.state.max_order_count}
            setMaxOrderCount={(max_order_count) =>
              this.setState({ max_order_count })
            }
          />

          {/*<AddModal*/}
          {/*  showModal={this.state.showAddModal}*/}
          {/*  noLogo={true}*/}
          {/*  handelCloseModal={this.handleCloseAddModal}*/}
          {/*  width="45%"*/}
          {/*  leftTitle={*/}
          {/*    <TitleLable>{isEvent ? 'Ticket' : 'Goodie'} hinzufügen</TitleLable>*/}
          {/*  }*/}
          {/*>*/}
          {/*  <Form*/}
          {/*    ref={this.formRef}*/}
          {/*    {...formLayout}*/}
          {/*    onChange={(e) => {*/}
          {/*      return setCanMove(false);*/}
          {/*    }}*/}
          {/*    name="rewards"*/}
          {/*    id="reward-form"*/}
          {/*    onFinish={this.onFinish}*/}
          {/*    validateMessages={formValidateMessages}*/}
          {/*    onFinishFailed={(error) => {*/}
          {/*      this.setState({ showErrors: true });*/}
          {/*    }}*/}
          {/*  >*/}
          {/*    <div>*/}
          {/*      <FormWrapper>*/}
          {/*        <>*/}
          {/*          /!* <b>Für Mobil- und Desktop-Optimierung Bilder bitte in verschiedenen Größen hochladen</b><br/> *!/*/}
          {/*          <UploadImageV2*/}
          {/*            multiple={false}*/}
          {/*            label={'Bild'}*/}
          {/*            name="image"*/}
          {/*            width={'200'}*/}
          {/*            height={'200'}*/}
          {/*            recommendedSize={'1000 x 1000'}*/}
          {/*            showErrors={this.state.showErrors}*/}
          {/*            errorTitle={'Bild'}*/}
          {/*            fileList={*/}
          {/*              //this.state.image?.length*/}
          {/*              //  ? convertUrlsToFiles(this.state.image)*/}
          {/*              null*/}
          {/*            }*/}
          {/*            setImage={this.setCoverImage}*/}
          {/*            images={this.state.image}*/}
          {/*            style={{ marginBottom: '16px' }}*/}
          {/*          />*/}

          {/*          <ModalFormItem*/}
          {/*            name="title"*/}
          {/*            label={<AddFormItemLabel>Bezeichnung</AddFormItemLabel>}*/}
          {/*            required={false}*/}
          {/*            rules={[*/}
          {/*              {*/}
          {/*                required: true,*/}
          {/*                message: 'Titel ist erforderlich',*/}
          {/*              },*/}
          {/*            ]}*/}
          {/*            onChange={(e) => {*/}
          {/*              this.setState({ title: e.target.value });*/}
          {/*            }}*/}
          {/*            initialValue={this.state.title}*/}
          {/*          >*/}
          {/*            <AddInput placeholder="Titel" />*/}
          {/*          </ModalFormItem>*/}

          {/*          <ModalFormItem*/}
          {/*            name="price"*/}
          {/*            label={<AddFormItemLabel>Preis</AddFormItemLabel>}*/}
          {/*            required={false}*/}
          {/*            rules={[*/}
          {/*              {*/}
          {/*                required: true,*/}
          {/*                message: 'Preis ist erforderlich',*/}
          {/*              },*/}
          {/*            ]}*/}
          {/*            onChange={(e) => {*/}
          {/*              const inputValue = e.target.value;*/}
          {/*              const floatValue = parseFloat(inputValue);*/}
          {/*              this.setState({*/}
          {/*                price:*/}
          {/*                  !isNaN(floatValue) && isFinite(floatValue)*/}
          {/*                    ? inputValue !== ''*/}
          {/*                      ? floatValue*/}
          {/*                      : undefined*/}
          {/*                    : undefined,*/}
          {/*              });*/}
          {/*            }}*/}
          {/*            initialValue={this.state.price}*/}
          {/*          >*/}
          {/*            <CurrencyWrapper>*/}
          {/*              <div className="custom-currency-input">*/}
          {/*                <AddInput*/}
          {/*                  class="input"*/}
          {/*                  type="number"*/}
          {/*                  step="any"*/}
          {/*                  placeholder="Preis"*/}
          {/*                  value={this.state.price}*/}
          {/*                  onChange={(e) => {*/}
          {/*                    const inputValue = e.target.value;*/}
          {/*                    const numericValue = Number(inputValue);*/}

          {/*                    // Check if the input is a valid number*/}
          {/*                    if (!isNaN(numericValue)) {*/}
          {/*                      this.setState({*/}
          {/*                        price: numericValue,*/}
          {/*                      });*/}
          {/*                    }*/}
          {/*                  }}*/}
          {/*                />*/}
          {/*              </div>*/}
          {/*            </CurrencyWrapper>*/}
          {/*          </ModalFormItem>*/}

          {/*          <ModalFormItem*/}
          {/*            name={'description'}*/}
          {/*            label={<AddFormItemLabel>Beschreibung</AddFormItemLabel>}*/}
          {/*            required={false}*/}
          {/*            rules={[*/}
          {/*              {*/}
          {/*                required: true,*/}
          {/*                message: 'Beschreibung ist erforderlich',*/}
          {/*              },*/}
          {/*            ]}*/}
          {/*            initialValue={this.state.description}*/}
          {/*          >*/}
          {/*            <RichText*/}
          {/*              name="description"*/}
          {/*              style={{ fontSize: '16px' }}*/}
          {/*              getContent={this.getContent}*/}
          {/*              placeholder="Beschreibung"*/}
          {/*            />*/}
          {/*          </ModalFormItem>*/}

          {/*          <ModalFormItem label={<AddLabel>Varianten</AddLabel>}>*/}
          {/*            <p style={{ fontSize: '14px', paddingBottom: '8px' }}>*/}
          {/*              Falls dein Produkt verschiedene Auswahlmöglichkeiten*/}
          {/*              bietet (z. B. Größen, Farben), kannst du sie hier*/}
          {/*              hinzufügen.*/}
          {/*            </p>*/}
          {/*            <FormList*/}
          {/*              name="variants"*/}
          {/*              initialValue={this.state.variants}*/}
          {/*              style={{*/}
          {/*                display: 'flex',*/}
          {/*                flexWrap: 'wrap',*/}
          {/*                gap: '8px',*/}
          {/*              }}*/}
          {/*            >*/}
          {/*              {(fields, { add, remove }) => (*/}
          {/*                <>*/}
          {/*                  <Button*/}
          {/*                    onClick={() => add()}*/}
          {/*                    block*/}
          {/*                    style={{*/}
          {/*                      width: '220px',*/}
          {/*                      color: '#3F621A',*/}
          {/*                      fontSize: '14px',*/}
          {/*                      fontWeight: '600',*/}
          {/*                      border: 'none',*/}
          {/*                      margin: '12px',*/}
          {/*                      marginLeft: '4px',*/}
          {/*                      padding: '0',*/}
          {/*                      paddingRight: '4px',*/}
          {/*                    }}*/}
          {/*                  >*/}
          {/*                    Auswahlmöglichkeit hinzufügen*/}
          {/*                  </Button>*/}
          {/*                  {fields.map(({ key, name, ...restField }) => (*/}
          {/*                    <div*/}
          {/*                      key={key}*/}
          {/*                      style={{*/}
          {/*                        border: '1px solid #eee',*/}
          {/*                        borderRadius: 8,*/}
          {/*                        padding: '4px',*/}
          {/*                        marginBottom: 12,*/}
          {/*                      }}*/}
          {/*                    >*/}
          {/*                      <FormItem*/}
          {/*                        {...restField}*/}
          {/*                        name={[name, 'attribute']}*/}
          {/*                        rules={[*/}
          {/*                          {*/}
          {/*                            required: true,*/}
          {/*                            message:*/}
          {/*                              'Bitte Auswahlmöglichkeit eingeben',*/}
          {/*                          },*/}
          {/*                        ]}*/}
          {/*                        style={{ marginBottom: '12px' }}*/}
          {/*                      >*/}
          {/*                        <AddInput placeholder="Auswahlmöglichkeit z.B. Größe oder Farbe" />*/}
          {/*                      </FormItem>*/}

          {/*                      <FormList*/}
          {/*                        name={[name, 'options']}*/}
          {/*                        style={{*/}
          {/*                          display: 'flex',*/}
          {/*                          flexWrap: 'wrap',*/}
          {/*                        }}*/}
          {/*                      >*/}
          {/*                        {(*/}
          {/*                          optionFields,*/}
          {/*                          { add: addOption, remove: removeOption }*/}
          {/*                        ) => (*/}
          {/*                          <div*/}
          {/*                            style={{*/}
          {/*                              display: 'flex',*/}
          {/*                              flexDirection: 'row',*/}
          {/*                              flexWrap: 'wrap',*/}
          {/*                              alignItems: 'center',*/}
          {/*                            }}*/}
          {/*                          >*/}
          {/*                            {optionFields.map(*/}
          {/*                              ({*/}
          {/*                                key: optionKey,*/}
          {/*                                name: optionName,*/}
          {/*                                ...optionRest*/}
          {/*                              }) => (*/}
          {/*                                <div*/}
          {/*                                  key={optionKey}*/}
          {/*                                  style={{*/}
          {/*                                    display: 'inline-flex',*/}
          {/*                                    alignItems: 'center',*/}
          {/*                                    margin: '4px',*/}
          {/*                                    padding: '4px 8px',*/}
          {/*                                    backgroundColor: '#FAFAFA',*/}
          {/*                                    borderRadius: '20px',*/}
          {/*                                    border: '1px solid #E9EAEB',*/}
          {/*                                    fontSize: '14px',*/}
          {/*                                    height: '28px',*/}
          {/*                                    flexWrap: 'nowrap',*/}
          {/*                                  }}*/}
          {/*                                >*/}
          {/*                                  <FormItem*/}
          {/*                                    {...optionRest}*/}
          {/*                                    name={[optionName]}*/}
          {/*                                    rules={[*/}
          {/*                                      {*/}
          {/*                                        required: true,*/}
          {/*                                        message: 'Variante eingeben',*/}
          {/*                                      },*/}
          {/*                                    ]}*/}
          {/*                                    style={{*/}
          {/*                                      flex: 1,*/}
          {/*                                      marginRight: '4px',*/}
          {/*                                      marginBottom: '0',*/}
          {/*                                    }}*/}
          {/*                                  >*/}
          {/*                                    <Input*/}
          {/*                                      style={{*/}
          {/*                                        width: 'auto',*/}
          {/*                                        height: '20px',*/}
          {/*                                        background: 'transparent',*/}
          {/*                                        border: 'none',*/}
          {/*                                        padding: '8px',*/}
          {/*                                      }}*/}
          {/*                                      placeholder="Variante eingeben"*/}
          {/*                                      onInput={(e) => {*/}
          {/*                                        e.target.style.width = `calc(${Math.max(*/}
          {/*                                          e.target.value.length,*/}
          {/*                                          1*/}
          {/*                                        )}ch + 16px)`;*/}
          {/*                                      }}*/}
          {/*                                    />*/}
          {/*                                  </FormItem>*/}
          {/*                                  <span*/}
          {/*                                    onClick={() => {*/}
          {/*                                      removeOption(optionName);*/}
          {/*                                      //const updated = [*/}
          {/*                                      //  ...this.formRef.current.getFieldValue(*/}
          {/*                                      //    'variants'*/}
          {/*                                      //  ),*/}
          {/*                                      //];*/}
          {/*                                      //updated.splice(optionName, 1);*/}
          {/*                                      //this.setState({*/}
          {/*                                      //  variants: updated,*/}
          {/*                                      //});*/}
          {/*                                    }}*/}
          {/*                                    style={{*/}
          {/*                                      cursor: 'pointer',*/}
          {/*                                      fontWeight: 'bold',*/}
          {/*                                      color: '#888',*/}
          {/*                                      userSelect: 'none',*/}
          {/*                                    }}*/}
          {/*                                  >*/}
          {/*                                    ×*/}
          {/*                                  </span>*/}
          {/*                                </div>*/}
          {/*                              )*/}
          {/*                            )}*/}
          {/*                            <FormItem style={{ marginBottom: '0' }}>*/}
          {/*                              <Button*/}
          {/*                                onClick={() => {*/}
          {/*                                  addOption();*/}
          {/*                                  //setTimeout(() => {*/}
          {/*                                  //  const variants =*/}
          {/*                                  //    this.formRef.current.getFieldValue(*/}
          {/*                                  //      'variants'*/}
          {/*                                  //    );*/}
          {/*                                  //  this.setState({ variants });*/}
          {/*                                  //}, 0);*/}
          {/*                                }}*/}
          {/*                                block*/}
          {/*                                style={{*/}
          {/*                                  width: '140px',*/}
          {/*                                  color: '#3F621A',*/}
          {/*                                  fontSize: '14px',*/}
          {/*                                  fontWeight: '600',*/}
          {/*                                  border: 'none',*/}
          {/*                                  marginLeft: '4px',*/}
          {/*                                  padding: '0',*/}
          {/*                                  paddingRight: '4px',*/}
          {/*                                }}*/}
          {/*                              >*/}
          {/*                                Variante hinzufügen*/}
          {/*                              </Button>*/}
          {/*                            </FormItem>*/}
          {/*                          </div>*/}
          {/*                        )}*/}
          {/*                      </FormList>*/}

          {/*                      <Button*/}
          {/*                        type="link"*/}
          {/*                        danger*/}
          {/*                        onClick={() => remove(name)}*/}
          {/*                        style={{*/}
          {/*                          marginLeft: 4,*/}
          {/*                          padding: 0,*/}
          {/*                          color: '#414651',*/}
          {/*                        }}*/}
          {/*                      >*/}
          {/*                        Auswahlmöglichkeit entfernen*/}
          {/*                      </Button>*/}
          {/*                      /!* Hidden input to trigger change *!/*/}
          {/*                      <FormItem noStyle shouldUpdate>*/}
          {/*                        {() => {*/}
          {/*                          const variants =*/}
          {/*                            this.formRef.current?.getFieldValue(*/}
          {/*                              'variants'*/}
          {/*                            ) || [];*/}
          {/*                          if (*/}
          {/*                            JSON.stringify(this.state.variants) !==*/}
          {/*                            JSON.stringify(variants)*/}
          {/*                          ) {*/}
          {/*                            this.setState({ variants });*/}
          {/*                          }*/}
          {/*                          return null;*/}
          {/*                        }}*/}
          {/*                      </FormItem>*/}
          {/*                    </div>*/}
          {/*                  ))}*/}
          {/*                </>*/}
          {/*              )}*/}
          {/*            </FormList>*/}
          {/*          </ModalFormItem>*/}

          {/*          {!isEvent && (*/}
          {/*            <ModalFormItem*/}
          {/*              name="shipping_date"*/}
          {/*              label={*/}
          {/*                <AddFormItemLabel>*/}
          {/*                  <AddLabel>Lieferzeitpunkt</AddLabel>*/}
          {/*                </AddFormItemLabel>*/}
          {/*              }*/}
          {/*              required={false}*/}
          {/*              rules={[*/}
          {/*                {*/}
          {/*                  required: true,*/}
          {/*                  message: 'Lieferzeitpunkt ist erforderlich',*/}
          {/*                },*/}
          {/*              ]}*/}
          {/*              initialValue={this.state.shipping_date ? 1 : 0}*/}
          {/*            >*/}
          {/*              <Radio.Group*/}
          {/*                onChange={(e) => {*/}
          {/*                  this.setState({ shipping_date: e.target.value });*/}
          {/*                }}*/}
          {/*                style={{ display: 'flex', flexDirection: 'column' }}*/}
          {/*              >*/}
          {/*                <Radio value={1}> Goodie ist sofort verfügbar </Radio>*/}
          {/*                <Radio value={0}>*/}
          {/*                  Goodie ist erst nach erfolgreichem Crowdfunding*/}
          {/*                  verfügbar*/}
          {/*                </Radio>*/}
          {/*              </Radio.Group>*/}
          {/*            </ModalFormItem>*/}
          {/*          )}*/}

          {/*          <AddLabel>Weitere Angaben</AddLabel>*/}

          {/*          <AddFormItem*/}
          {/*            name="address_required"*/}
          {/*            onChange={(e) => {*/}
          {/*              this.setState({ address_required: e.target.checked });*/}
          {/*            }}*/}
          {/*          >*/}
          {/*            <Checkbox checked={this.state.address_required}>*/}
          {/*              Lieferadresse des Unterstützers benötigt*/}
          {/*            </Checkbox>*/}
          {/*          </AddFormItem>*/}

          {/*          <AddFormItem*/}
          {/*            name="no_multi_order"*/}
          {/*            onChange={(e) => {*/}
          {/*              this.setState({ no_multi_order: e.target.checked });*/}
          {/*            }}*/}
          {/*          >*/}
          {/*            <Checkbox checked={this.state.no_multi_order}>*/}
          {/*              {isEvent*/}
          {/*                ? 'Nur ein Ticket pro Unterstützer'*/}
          {/*                : 'Nur ein Goodie pro Unterstützer'}*/}
          {/*            </Checkbox>*/}
          {/*          </AddFormItem>*/}

          {/*          <AddFormItem*/}
          {/*            name="show_extra_details"*/}
          {/*            extra={*/}
          {/*              isEvent*/}
          {/*                ? 'Falls dein Ticket eine Angabe vom Käufer benötigt, kannst du hier eine anfordern.'*/}
          {/*                : 'Falls dein Produkt personalisierbar ist, kannst du hier eine Angabe anfordern.'*/}
          {/*            }*/}
          {/*          >*/}
          {/*            <Checkbox*/}
          {/*              onChange={(e) => {*/}
          {/*                this.setState({ showExtraDetails: e.target.checked });*/}
          {/*              }}*/}
          {/*              checked={this.state.showExtraDetails}*/}
          {/*            >*/}
          {/*              Unterstützer müssen eine Angabe machen*/}
          {/*            </Checkbox>*/}
          {/*          </AddFormItem>*/}

          {/*          {this.state.showExtraDetails && (*/}
          {/*            <AddFormItem*/}
          {/*              name="extra_details"*/}
          {/*              onChange={(e) => {*/}
          {/*                this.setState({ extra_details: e.target.value });*/}
          {/*              }}*/}
          {/*              initialValue={this.state.extra_details}*/}
          {/*            >*/}
          {/*              <AddInput*/}
          {/*                type="string"*/}
          {/*                min={1}*/}
          {/*                placeholder='Eingabeaufforderung (z. B. "Name für Gravur")'*/}
          {/*              />*/}
          {/*            </AddFormItem>*/}
          {/*          )}*/}

          {/*          <AddFormItem name="show_max_stock">*/}
          {/*            <Checkbox*/}
          {/*              onChange={(e) => {*/}
          {/*                this.setState({ showMaxStock: e.target.checked });*/}
          {/*              }}*/}
          {/*              checked={this.state.showMaxStock}*/}
          {/*            >*/}
          {/*              Stückzahl ist limitiert*/}
          {/*            </Checkbox>*/}
          {/*          </AddFormItem>*/}

          {/*          {this.state.showMaxStock && (*/}
          {/*            <AddFormItem*/}
          {/*              name="max_order_count"*/}
          {/*              onChange={(e) => {*/}
          {/*                this.setState({ max_order_count: e.target.value });*/}
          {/*              }}*/}
          {/*              initialValue={this.state.max_order_count}*/}
          {/*            >*/}
          {/*              <AddInput*/}
          {/*                type="number"*/}
          {/*                min={1}*/}
          {/*                placeholder="Stückzahl eingeben"*/}
          {/*              />*/}
          {/*            </AddFormItem>*/}
          {/*          )}*/}

          {/*          <FormItem*/}
          {/*            style={{*/}
          {/*              marginBottom: '0',*/}
          {/*            }}*/}
          {/*          >*/}
          {/*            <AddButtonWrapper>*/}
          {/*              <div className="space-between">*/}
          {/*                <PrimaryButtonV2*/}
          {/*                  primary="true"*/}
          {/*                  onClick={this.handleCloseAddModal}*/}
          {/*                >*/}
          {/*                  <p>Abbrechen</p>*/}
          {/*                </PrimaryButtonV2>*/}
          {/*                <PrimaryButtonV2*/}
          {/*                  type="primary"*/}
          {/*                  htmltype="submit"*/}
          {/*                  id="submit-button"*/}
          {/*                >*/}
          {/*                  <p>Hinzufügen</p>*/}
          {/*                </PrimaryButtonV2>*/}
          {/*              </div>*/}
          {/*            </AddButtonWrapper>*/}
          {/*          </FormItem>*/}
          {/*        </>*/}
          {/*      </FormWrapper>*/}
          {/*    </div>*/}
          {/*  </Form>*/}
          {/*</AddModal>*/}

          {editProject && <AddSaveHint />}

          <SpaceBetween>
            <SecondaryButton
              type="button"
              minWidth="120px"
              onClick={this.onReturn}
            >
              {editProject ? (
                <p>Zurück zur Projektübersicht</p>
              ) : (
                <>
                  <ArrowLeftOutlined />
                  <p>Zurück</p>
                </>
              )}
            </SecondaryButton>

            <PrimaryButtonV2
              type="primary"
              minWidth="120px"
              onClick={this.onContinue}
            >
              {editProject ? (
                <p>Speichern*</p>
              ) : (
                <>
                  <p>Weiter</p>
                  <ArrowRightOutlined />
                </>
              )}
            </PrimaryButtonV2>
          </SpaceBetween>
        </Spin>
      </Container>
    );
  }
}
const mapStateToProps = (state) => {
  const { currentStep, project, loading, errors, isUniq } = state.projects;
  return {
    currentStep,
    project,
    loading,
    errors,
    isUniq,
  };
};

const mapDispatchToProps = (dispatch) => ({
  checkUrl: (url) => dispatch(ProjectsActions.checkUrl(url)),
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Rewards);


const IntroBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 12px;
  max-width: 600px;
    margin: 0 auto;
  width: 100%;
  align-self: stretch;
`;

const IntroTitle = styled.h1`
  margin: 35px 0 0 0px !important;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: #181d27;
`;

const IntroLead = styled.p`
  margin: 0;
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px !important;
  line-height: 28px;
  color: #535862;
    padding-bottom: 0px !important;
`;

const IntroText = styled.p`
  margin: 0;
  width: 100%;
  font-family: 'Inter', sans-serif !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px !important;
  line-height: 24px !important;
  color: #535862 !important;
  padding-bottom: 0px !important;
`;

const IntroList = styled.ul`
  margin: 0;
  padding-left: 24px;
  width: 100%;

  li {
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #535862;
    margin-bottom: 0;
  }
`;
